export enum MembershipFeeView {
  PERSONS = 1,
  TEAMS = 2,
  STATISTIC_REGIONS = 3,
  STATISTIC_DISTRICTS = 4,
  STATISTIC_CLUBS = 5,
  CP_STATISTIC_REGIONS = 6,
  CP_STATISTIC_DISTRICTS = 7,
  CP_STATISTIC_CLUBS = 8,
}
